// extracted by mini-css-extract-plugin
export var acitonButtons = "_12-0";
export var additionalIcon = "_12-f";
export var block = "_12-1";
export var blockContent = "_12-7";
export var blockDescription = "_12-8";
export var blockIcon = "_12-9";
export var blockTitle = "_12-6";
export var border = "_12-a";
export var center = "_12-l";
export var edge = "_12-b";
export var edgeLabel = "_12-c";
export var edgePath = "_12-d";
export var error = "_12-e";
export var flowchart = "_12-g";
export var flowchartContent = "_12-h";
export var highlighted = "_12-3";
export var hover = "_12-4";
export var icon = "_12-i";
export var left = "_12-m";
export var navButton = "_12-j";
export var navButtons = "_12-k";
export var right = "_12-n";
export var selected = "_12-2";
export var small = "_12-5";